import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/Home',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/Listagem-placa/',
    name: 'ListaVistoriasPlaca',
    props: true,
    component: () => import('../views/ListagemPlaca.vue')
  },
  {
    path: '/Listagem-periodo',
    name: 'ListaVistoriasPeriodo',
    component: () => import('../views/ListagemPeriodo.vue')
  },
  {
    path: '/Historico',
    name: 'Historico',
    component: () => import('../views/Historico.vue')
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/Dados-pessoais',
    name: 'DadosPessoais',
    component: () => import('../views/DadosPessoais.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
